export default {
  'invoiceNoteItems.label.items': 'Total Itens',
  'invoiceNoteItems.label.insurance': 'Total Seguro',
  'invoiceNoteItems.label.freight': 'Total Frete',
  'invoiceNoteItems.label.expenses': 'Total Despesas',
  'invoiceNoteItems.label.discount': 'Total Desconto',
  'invoiceNoteItems.label.grade': 'Total Nota',
  'invoiceNoteItems.label.codeServices': 'Código Serviços',
  'invoiceNoteItems.label.deductioValue': 'Valor Deduções',
  'invoiceNoteItems.label.conditionedDiscount': 'Desconto Condicionado',
  'invoiceNoteItems.label.unconditionalDiscount': 'Desconto Incondicionado',
  'invoiceNoteItems.label.totalAmount': 'Valor Total',

  'invoiceNoteItems.column.internalCode': 'Código Interno',
  'invoiceNoteItems.column.description': 'Descrição',
  'invoiceNoteItems.column.cfop': 'CFOP',
  'invoiceNoteItems.column.ncm': 'NCM',
  'invoiceNoteItems.column.itemNumber': 'Núm. item',
  'invoiceNoteItems.column.qty': 'Qtde.',
  'invoiceNoteItems.column.unitPrice': 'Preço Unitário',
  'invoiceNoteItems.column.discount': 'Desconto',
  'invoiceNoteItems.column.discountUnconditioned': 'Desconto incondicionado',
  'invoiceNoteItems.column.totalAmount': 'Valor Total',
  'invoiceNoteItems.column.rate': 'Alíquota',

  'invoiceNoteItems.button.selectPart': 'Selecionar uma Peça',
  'invoiceNoteItems.button.updateTaxes': 'Atualizar Tributos',
  'invoiceNoteItems.button.selectService': 'Incluir Serviço',
  'invoiceNoteItems.button.deleteSelectedServices':
    'Excluir serviços selecionados',
  'invoiceNoteItems.button.includeService': 'Incluir Serviço',

  'invoiceNoteItems.create.notifications.success.title': 'Sucesso',
  'invoiceNoteItems.create.notifications.success.description':
    'Item da nota criado com Sucesso!',
};
